import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import './VirtualTryOn.scss';

/**
 * Loading Overlay with Blur Effect
 * Displayed while generating virtual try-on image
 */
const TryOnLoadingOverlay = ({ productImage }) => {
  const { t } = useTranslation();

  return (
    <div className='tryon-loading-overlay'>
      {/* Blurred background image */}
      <div className='tryon-loading-overlay__background' style={{ backgroundImage: `url(${productImage})` }} />

      {/* Loading content */}
      <div className='tryon-loading-overlay__content'>
        <div className='tryon-loading-overlay__spinner'>
          <Sparkles className='tryon-loading-overlay__icon' size={48} />
        </div>
        <h3 className='tryon-loading-overlay__title'>{t('Generating your try-on...')}</h3>
        <p className='tryon-loading-overlay__subtitle'>{t('This will only take a moment')}</p>

        {/* Progress bar */}
        <div className='tryon-loading-overlay__progress'>
          <div className='tryon-loading-overlay__progress-bar' />
        </div>
      </div>
    </div>
  );
};

TryOnLoadingOverlay.propTypes = {
  productImage: PropTypes.string.isRequired,
};

export default TryOnLoadingOverlay;
